import { useState } from 'react';
import { PaymentsList } from '@/modules/billing';
import { useSubscriberPayments } from '../api';

export function SubscriberPayments({ id }: { id: string }) {
  const [page, setPage] = useState(1);
  const payments = useSubscriberPayments(id, page);

  return (
    <PaymentsList orders={payments.data} isLoading={payments.isLoading} onPageChange={setPage} />
  );
}
